module.exports = __webpack_public_path__ + "img/t5.eecf2eab.jpg";